mutation homeNumberUpdate ($id: ID!, $label: String, $studentIds: [ID], $homeLanguageId: ID, $tz: String) {
  homeNumberUpdate (id: $id, label: $label, studentIds: $studentIds, homeLanguageId: $homeLanguageId) {
    id
    label
    formattedNumber
    number
    deletedAt(tz: $tz)
    deletingTeacher {
      id
      first
      isCurrent
      last
    }
    archivedAt(tz: $tz)
    archivingTeacher {
      id
      first
      isCurrent
      last
    }
    blockedAt(tz: $tz)
    blockingTeacher {
      id
      first
      isCurrent
      last
    }
    conversations {
      teacherPhoneNumber {
        id
        displayName
      }
    }
    homeLanguage {
      id
      name
      language
    }
    students {
      id
      first
      last
    }
  }
}
